/*
 * EducationPanel — v2.7 §F.1: a display-only price-tier card shown right
 * before Orbit asks about budget. NOT a question — just calibration so
 * the user's answer to §F.2 (budget_tier) is grounded in real numbers.
 *
 * Renders inline in the chat thread between Orbit's last question and
 * the composer. Dismissible once seen.
 */

import React from 'react';
import { Info } from 'lucide-react';


export interface EducationPanelProps {
  onAcknowledge?: () => void;
}


const TIERS: Array<{ label: string; price: string; what: string }> = [
  { label: 'Skill packs',  price: '~$100',     what: 'Dept-level mini-tools, plug-and-play' },
  { label: 'Agent',        price: '~$5k',      what: 'One workflow automated end-to-end' },
  { label: 'Platform',     price: '$150k+',    what: 'Org-wide deployment, multiple agents' },
  { label: 'Enterprise',   price: '$1M+',      what: 'Custom architecture, regulated scale' },
];


export function EducationPanel({ onAcknowledge }: EducationPanelProps) {
  return (
    <section className="aa-edu" aria-label="Budget context">
      <header className="aa-edu-head">
        <Info size={14} aria-hidden="true" />
        <span>Quick context before we talk budget</span>
      </header>
      <ul className="aa-edu-list">
        {TIERS.map(t => (
          <li key={t.label} className="aa-edu-row">
            <span className="aa-edu-tier">{t.label}</span>
            <span className="aa-edu-price">{t.price}</span>
            <span className="aa-edu-what">{t.what}</span>
          </li>
        ))}
      </ul>
      {onAcknowledge && (
        <button type="button" className="aa-edu-ack" onClick={onAcknowledge}>
          Got it
        </button>
      )}
    </section>
  );
}

export default EducationPanel;
